import React from 'react'
import PropTypes from 'prop-types'
import { Button, Form, FormGroup, FormInput, Card, CardBody } from 'shards-react'

import Validate from '../../../services/validate-service/Validate'
import withLoading from '../../../hocs/withLoading/withLoading'

import './../reset-password.css'

const AdmFormReset = props => {
    const { email, setEmail, sendEmail } = props
    AdmFormReset.propTypes = {
        sendEmail: PropTypes.func,
        email: PropTypes.string,
        setEmail: PropTypes.func,
    }

    return (
        <div className={'form-reset--container'}>
            <Card>
                <CardBody>
                    <Form onSubmit={sendEmail} style={{ marginBottom: '10px' }}>
                        <FormGroup>
                            <label htmlFor="email">
                                Repita o email do usuário e enviaremos um link para redefinição de senha.
                            </label>
                            <FormInput
                                required
                                placeholder={email}
                                name={'email'}
                                valid={Validate.emailValidate(email)}
                                onChange={e => setEmail(e.target.value)}
                            />
                        </FormGroup>
                        <Button block className={'form-auth--bt-login'}>
                            Enviar
                        </Button>
                    </Form>
                </CardBody>
            </Card>
        </div>
    )
}

const WrappedComponent = withLoading(AdmFormReset)
export default WrappedComponent
